import { useRef, useState, useEffect } from 'react';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import userService from '../../service/userService';
import toast from '../../service/toaster';
import { consumeRedirectPath } from '../../service/authRedirect';
import './auth.css';

const Login = () => {
  const [validated, setValidated] = useState(false);
  const [usercreds, setUsercreds] = useState({
    email: '',
    password: ''
  });
  const googleBtnRef = useRef(null);
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '489075978798-led1v9pogg4htnqqonmp0j1ra4j9cbdh.apps.googleusercontent.com';
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const redirectTarget = consumeRedirectPath();

  const loadGoogleScript = () => {
    return new Promise((resolve, reject) => {
      if (window.google?.accounts?.id) return resolve();
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  };

  const handleGoogleCredentialResponse = async (response) => {
    const idToken = response?.credential;
    if (!idToken) return;
    try {
      const resp = await userService.googleAuth({ idToken });
      toast.success(resp.message || 'Logged in with Google');
      localStorage.setItem('token', resp.data.token);
      localStorage.setItem('userDetails', JSON.stringify(resp.data));
      navigate(redirectTarget || location.state?.from || '/');
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    loadGoogleScript()
      .then(() => {
        if (!window.google || !GOOGLE_CLIENT_ID) return;
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleGoogleCredentialResponse
        });
        if (googleBtnRef.current) {
          window.google.accounts.id.renderButton(googleBtnRef.current, { theme: 'outline', size: 'large', width: 220 });
        }
      })
      .catch(() => {
        console.warn('Google script failed to load');
      });
  }, []);

  const credHandler = (event) => {
    setUsercreds((creds) => ({ ...creds, [event.target.name]: event.target.value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      userService
        .login(usercreds)
        .then((resp) => {
          toast.success(resp.message);
          localStorage.setItem('token', resp.data.token);
          localStorage.setItem('userDetails', JSON.stringify(resp.data));
          navigate(redirectTarget || location.state?.from || '/');
        })
        .catch((err) => {
          toast.error(err.message);
          console.log(err);
        });
    }

    setValidated(true);
  };

  return (
    <div className="auth-page">
      <div className="wrapper auth-wrapper">
        <Form noValidate validated={validated} onSubmit={handleSubmit} className="login auth-card">
          <div className="body-str">
            <h2 className="text-center auth-brand">
              <img src={require('../../assets/cricket-player.png')} alt="Cricket Prediction Logo" />
              <span>Cricket Prediction</span>
            </h2>
            <hr />
            <h4 className="text-center">Login</h4>

            <Row className="mb-2">
              <Form.Group as={Col} md="16" controlId="validationCustomUsername">
                <Form.Label>Email</Form.Label>
                <InputGroup hasValidation>
                  <InputGroup.Text id="inputGroupPrepend">
                    <span className="fa fa-user"></span>
                  </InputGroup.Text>
                  <Form.Control type="text" name="email" placeholder="Email" onChange={credHandler} aria-describedby="inputGroupPrepend" required />
                  <Form.Control.Feedback type="invalid">Please provide email.</Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="16" controlId="validationCustom03">
                <Form.Label>Password</Form.Label>
                <InputGroup hasValidation>
                  <InputGroup.Text id="inputGroupPrepend">
                    <span className="fa fa-lock"></span>
                  </InputGroup.Text>
                  <Form.Control type={showPassword ? 'text' : 'password'} name="password" onChange={credHandler} placeholder="Password" required />
                  <Button
                    type="button"
                    variant="outline-secondary"
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                  >
                    <span className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></span>
                  </Button>
                  <Form.Control.Feedback type="invalid">Please provide password.</Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Row>

            <div className="auth-links">
              <button type="button" className="auth-link-btn" onClick={() => navigate('/getOTP')}>
                Forgot Password?
              </button>
              <button type="button" className="auth-link-btn" onClick={() => navigate('/register')}>
                Create Account
              </button>
            </div>

            <div className="auth-submit-wrap">
              <Button type="submit">Login</Button>
            </div>

            <div className="auth-oauth">
              <div className="auth-oauth-note">or continue with</div>
              <div ref={googleBtnRef} style={{ marginTop: '8px', display: 'flex', justifyContent: 'center' }} />
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;
